import { ONBOARDING_ROLE_ID } from 'Common/constants/onboarding';

export const getBasisRoleId = (roleIdsStr) => {
  const { CONTRACTOR: contractor, EMPLOYEE: employee } = ONBOARDING_ROLE_ID;
  const roleIds = roleIdsStr.split(',');
  const isContractor = roleIds.includes(contractor.toString());
  return isContractor ? contractor : employee;
};
